import { render, staticRenderFns } from "./AdditionalParts.vue?vue&type=template&id=300739d0&scoped=true&"
import script from "./AdditionalParts.vue?vue&type=script&lang=js&"
export * from "./AdditionalParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300739d0",
  null
  
)

export default component.exports